module.exports = __webpack_public_path__ + "img/privilege14.b18742ce.png";